export default __webpack_public_path__ + "static/media/mb-logo.b602dada.png";